interface Props {
  className?: string;
}

export function TBankLogo({className}: Props): JSX.Element {
  return (
    <svg
      width="93"
      height="32"
      viewBox="0 0 93 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M45.5067 15.1616C44.8784 14.9341 44.0567 14.8659 43.1626 14.8659H38.1839V13.4095H46.7393V10.9064H34.6797V21.7381H42.8483C43.9842 21.7381 44.8299 21.6471 45.4584 21.4194C46.7876 20.9415 47.6818 19.781 47.6818 18.2564C47.6818 16.7091 46.8359 15.6395 45.5067 15.1616ZM43.7666 18.9163C43.5733 18.9847 43.3075 19.0073 42.969 19.0073H38.1839V17.2779H42.969C43.3559 17.2779 43.6699 17.3008 43.9117 17.4145C44.2016 17.5511 44.3466 17.8014 44.3466 18.1199C44.3466 18.4384 44.1775 18.7798 43.7666 18.9163Z"
        fill="white"
      />
      <path
        d="M57.5079 10.9064H52.3845L47.6719 21.7381H51.6354L52.2879 20.1679H57.6046L58.2814 21.7381H62.2207L57.5079 10.9064ZM53.1578 17.7785L54.8255 13.4095H55.0913L56.7588 17.7785H53.1578Z"
        fill="white"
      />
      <path
        d="M66.7307 17.7104V21.7381H63.2266V10.9064H66.7307V14.8659H72.3617V10.9064H75.866V21.7381H72.3617V17.7104H66.7307Z"
        fill="white"
      />
      <path
        d="M81.4145 17.6421V21.7381H77.9102V10.9064H81.4145V14.9797H82.3812L86.6105 10.9064H91.0088L85.402 16.0947L91.2264 21.7381H86.5621L82.3812 17.6421H81.4145Z"
        fill="white"
      />
      <path
        d="M0.167969 3.94336H28.1051V17.1731C28.1051 20.5646 26.1836 23.6986 23.0644 25.3945L14.1365 30.2487L5.20865 25.3945C2.08944 23.6986 0.167969 20.5646 0.167969 17.1731V3.94336Z"
        fill="#FFDD2D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.83594 10.9064V15.0211C8.43351 14.3857 9.52 13.9557 10.7623 13.9557H12.1123V18.739C12.1123 20.0116 11.745 21.1254 11.2002 21.7381H17.0724C16.5287 21.1248 16.1623 20.0124 16.1623 18.7414V13.9557H17.5124C18.7546 13.9557 19.8411 14.3857 20.4387 15.0211V10.9064H7.83594Z"
        fill="#333333"
      />
    </svg>
  );
}
